export type CollectionType =
  | 'geography'
  | 'segment'
  | 'strategic_team'
  | 'named_accounts'

export type CollectionCreationStep =
  | 'closed'
  | 'selectType'
  | 'nameCollection'
  | 'selectMembers'

export type TeamMember = {
  id: string
  name: string
  role: string
  location: string
  avatarUrl?: string
  /** Names of people this AE has engaged with (for “Engaged with” stack). */
  engagedWith: string[]
}

export type CollectionMetric = {
  count: number
  /** Absolute currency amount in USD (e.g. 200000 → "$ 200K"). */
  amount: number
}

export type CollectionMetrics = {
  closedWon: CollectionMetric
  inProgress: CollectionMetric
  closedLost: CollectionMetric
}

export type TeamCollection = {
  id: string
  name: string
  type: CollectionType
  memberIds: string[]
  createdAt: string
  createdBy: string
  metrics: CollectionMetrics
  isArchived: boolean
}

export const EMPTY_COLLECTION_METRICS: CollectionMetrics = {
  closedWon: { count: 0, amount: 0 },
  inProgress: { count: 0, amount: 0 },
  closedLost: { count: 0, amount: 0 },
}

export type CollectionDraft = {
  type: CollectionType | null
  name: string
  selectedMemberIds: string[]
}

export type TeamRelationshipState = {
  /** Normalized collection entities for O(1) lookup. */
  collectionsById: Record<string, TeamCollection>
  /** Ordered collection ids for list rendering. */
  collectionIds: string[]
  /** Available AEs / members for assignment (dummy until API). */
  membersById: Record<string, TeamMember>
  memberIds: string[]
  /** Create-collection wizard step. */
  creationStep: CollectionCreationStep
  /** In-progress create form (type + name + selected members). */
  draft: CollectionDraft
}
